
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return require("private-next-pages/dashboard/index.js");
      }
    ]);
  